module.exports = __webpack_public_path__ + "img/glassquality_5.32bf6dc8.png";